"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = Object.freeze((0, _keyMirror.default)({
  NOT_AN_IMAGE: null,
  INVALID_FILE_EXTENSION: null
}));

exports.default = _default;
module.exports = exports.default;